import { getValueFor } from './product';

/** When `use_product_is_new_design` is false, all products use the new product page. */
export function isNewProductDesignForced(
  remoteConfigData: unknown,
): boolean {
  if (!remoteConfigData || typeof remoteConfigData !== 'object') {
    return false;
  }
  return (
    (remoteConfigData as Record<string, unknown>).use_product_is_new_design ===
    false
  );
}

export function shouldNavigateToNewProductPage(
  category: any,
  remoteConfigData?: unknown,
): boolean {
  if (isNewProductDesignForced(remoteConfigData)) {
    return true;
  }
  return getValueFor('isNewMenu', category?.metadata) === 'true';
}

export function findCategoryForProduct(
  categories: { categories?: { products?: { id: number }[] }[] } | null | undefined,
  productId: number,
): any {
  for (const cat of categories?.categories ?? []) {
    if (cat.products?.some((p) => p.id === productId)) {
      return cat;
    }
  }
  return null;
}

export const getProductUrl = (
  category: any,
  item: { id: number | string },
  remoteConfigData?: unknown,
  editBasketLineId?: number | string,
): string => {
  const productId = item.id;
  const useNew = shouldNavigateToNewProductPage(category, remoteConfigData);

  if (editBasketLineId != null && editBasketLineId !== '') {
    const editSegment = String(editBasketLineId);
    const base = useNew
      ? `/product/new/${productId}/${editSegment}`
      : `/product/${productId}/${editSegment}`;
    return `${base}?edit=true`;
  }

  return useNew ? `/product/new/${productId}` : `/product/${productId}`;
};

/** Resolve product URL when category is unknown (e.g. deep link after location change). */
export function getProductUrlForProductId(
  productId: number | string,
  remoteConfigData?: unknown,
  categories?: { categories?: any[] } | null,
): string {
  if (isNewProductDesignForced(remoteConfigData)) {
    return `/product/new/${productId}`;
  }

  const category = findCategoryForProduct(
    categories ?? null,
    Number(productId),
  );
  if (category) {
    return getProductUrl(category, { id: productId }, remoteConfigData);
  }

  return `/product/${productId}`;
};

/** Relative path for cart `navigate()` (no leading slash). */
export function getProductEditNavigatePath(
  productId: number | string,
  basketLineId: number | string,
  remoteConfigData: unknown,
  categories: { categories?: any[] } | null | undefined,
  appendEditQuery: boolean,
): string {
  const category = findCategoryForProduct(categories, Number(productId));
  const useNew = shouldNavigateToNewProductPage(category ?? {}, remoteConfigData);
  const prefix = useNew ? 'product/new' : 'product';
  let path = `${prefix}/${productId}/${basketLineId}`;
  if (appendEditQuery) {
    path += '?edit=true';
  }
  return path;
};
